function initBenefitsTable() {
  const links = document.querySelectorAll('.benefits-table__link[display-type="flyout"]');
  const closeAside = document.querySelectorAll('.benefits-table__aside-close');
  let activeLink = null;

  const closeAllAside = () => {
    const asideArray = document.querySelectorAll('.benefits-table__aside');
    asideArray.forEach((asideItem) => {
      asideItem.classList.remove('open');
    });
  };

  const closeAllLink = () => {
    const linksArray = document.querySelectorAll('.benefits-table__link.active');
    linksArray.forEach((linkItem) => {
      linkItem.classList.remove('active');
    });
  };

  const openFlyoutByBenefitId = (benefitId) => {
    const aside = document.querySelector(`.benefits-table__aside[data-benefit-id="${benefitId}"]`);
    if (!aside) {
      return;
    }

    const row = aside.previousElementSibling;
    const link = row?.querySelector('.benefits-table__link');
    if (!link) {
      return;
    }

    closeAllAside();
    closeAllLink();
    activeLink = link;
    link.classList.add('active');
    aside.classList.add('open');
  };

  links.forEach((item) => {
    const aside = item.closest('.table__row').nextElementSibling;

    item.addEventListener('click', (e) => {
      closeAllAside();
      activeLink = item;
      closeAllLink();
      activeLink.classList.add('active');
      aside.classList.add('open');
      e.preventDefault();
    });
  });
  closeAside.forEach((item) => {
    item.addEventListener('click', (e) => {
      closeAllAside();
      closeAllLink();
      e.preventDefault();
    });
  });

  document.addEventListener('click', (e) => {
    const aside = document.querySelector('.benefits-table__aside.open');
    if (!aside) {
      return;
    }

    const isClickInsideAside = aside.contains(e.target);
    const isClickOnLink = e.target.closest('.benefits-table__link[display-type="flyout"]');

    if (!isClickInsideAside && !isClickOnLink) {
      closeAllAside();
      closeAllLink();
    }
  });

  // eslint-disable-next-line no-shadow
  function handleHashNavigation(openFlyoutByBenefitId) {
    const hash = window.location.hash.replace('#', '');
    if (!hash) {
      return;
    }

    const anchor = document.getElementById('benefits-flyout');
    if (!anchor) {
      return;
    }

    window.history.replaceState(null, '', window.location.pathname + window.location.search);

    requestAnimationFrame(() => {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(() => {
        openFlyoutByBenefitId(hash);
      }, 500);
    });
  }

  handleHashNavigation(openFlyoutByBenefitId);

  // Handle hash changes when user is already on the page
  window.addEventListener('hashchange', () => {
    handleHashNavigation(openFlyoutByBenefitId);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/slider', () => {
      initBenefitsTable();
    });
  } else {
    initBenefitsTable();
  }
});
